import React from 'react';
import Loading from './loading';
import { useLoader } from '@/hooks/loader-context';

const AxiosLoader: React.FC = () => {
  const { loading } = useLoader();

  if (!loading) return null;

  return (
    <>
        <Loading loading={loading} />
    </>
  );
};

export default AxiosLoader;
